import { BooleanLiteral } from "typescript";

export class Configuration {
  courseName: string;
  cssColor: string;
  rgb: string;
  productIds: number[];
  simulation: string;
  simulationFullName: string;
  menu: Menu;
  isDemo: boolean;
  noRankingMode: boolean;
  logoutText: string;
  currentLanguage: string;
  supportedLanguages: LanguageChoice[];
  blockedByDemoTexts: BlockedByDemoTexts;
  uiConfiguration: InterfaceType;
  languageTitleText: string;
  languageSubTitleText: string;
  documentsText: string;
  documentUrl: string;
  onboardingUrl: string;
  onboardingText: string;
  firstPageUrl: string;
  teamText: string;
  teamUrl: string;
  languagesText: string;
  displayLogOut: boolean;
  displayTeam: boolean;
  displayTeamMode: string;
  screenReaderFriendly: boolean;
  highContrast: boolean;
  enableScreenReaderMode: boolean;
  enableHighContrasts: boolean;
  enableHighContrastsText: string;
  disableHighContrastsText: string;
  enableScreenReaderText: string;
  disableScreenReaderText: string;
  useWideDecision: boolean;
  useTestDecisions: boolean;
  needHelpText: string;
  isDecisionReadOnly: boolean;
  isDecisionValidated: boolean;
  useRowNumbering: boolean;
  canReleaseDecision: boolean;
  userPilotLaunchScriptId: string;
}

export enum Simulation {
  CARS = 29,
  FIN = 33,
}

export enum InterfaceType {
  Unknown = 0,
  CvcOriginal = 1,
  Cvc = 2,
  CvcLight4BU = 3,
  CvcLight2BU = 4,
  CvcLight1BULowCost = 5,
  CvcLight1BUImage = 6,
  Fof = 7,
  Tca = 8,
  FofDemo = 9,
  CvcLight1BULowCostDemo = 10,
  CvcLight1BUImageDemo = 11,
  FofSLB = 12,
  Hcc = 13,
}

export class Menu {
  items: MenuItem[];
  decision: MenuItem;
  signOutUrl: string;
}

export class MenuItem {
  path: string;
  caption: string;
  regionId: number;
  withSeparator: boolean;
  noEncode: boolean;
  notAccessibleInDemo: boolean;
  items: MenuItem[];
}

export class BlockedByDemoTexts {
  cancelText: string;
  contentText: string;
  titleText: string;
}

export class LanguageChoice {
  language: string;
  caption: string;
}
